'use client';

import { c as _c } from "react/compiler-runtime";
import type { LoteChartsSectionProps } from '../../types/lote.types';
import { TemperatureDistributionChart } from './TemperatureDistributionChart';
import { ConversionTimelineChart } from './ConversionTimelineChart';
import { TimeMetricsChart } from './TimeMetricsChart';
export function LoteChartsSection(t0) {
  const $ = _c(14);
  const {
    chartData,
    isLoading
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-3">{[1, 2, 3].map(_temp)}</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-1"><h3 className="text-body-bold font-body-bold text-default-font">Distribuição por Temperatura</h3><p className="text-caption font-caption text-subtext-color">Visão geral das negociações por nível de calor</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== chartData.temperatureDistribution) {
    t2 = <div className="flex flex-col gap-3 rounded-xl border border-neutral-200 bg-white p-5">{t1}<div className="h-64"><TemperatureDistributionChart data={chartData.temperatureDistribution} /></div></div>;
    $[2] = chartData.temperatureDistribution;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-1"><h3 className="text-body-bold font-body-bold text-default-font">Timeline de Conversões</h3><p className="text-caption font-caption text-subtext-color">Acordos fechados vs sem acordo nos últimos 30 dias</p></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== chartData.conversionTimeline) {
    t4 = <div className="flex flex-col gap-3 rounded-xl border border-neutral-200 bg-white p-5">{t3}<div className="h-64"><ConversionTimelineChart data={chartData.conversionTimeline} /></div></div>;
    $[5] = chartData.conversionTimeline;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-1"><h3 className="text-body-bold font-body-bold text-default-font">Métricas de Tempo</h3><p className="text-caption font-caption text-subtext-color">Tempo médio por temperatura de negociação</p></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== chartData.timeMetrics) {
    t6 = <div className="flex flex-col gap-3 rounded-xl border border-neutral-200 bg-white p-5">{t5}<div className="h-64"><TimeMetricsChart data={chartData.timeMetrics} /></div></div>;
    $[8] = chartData.timeMetrics;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-3">{t2}{t4}{t6}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp(i) {
  return <div key={i} className="flex h-80 animate-pulse items-center justify-center rounded-xl border border-neutral-200 bg-neutral-50"><div className="h-32 w-32 rounded-full bg-neutral-200" /></div>;
}